<template>
<Transition appear name="fade">
  <div class="main-container" id="header">
    <div 
      class="header-div"
      v-bind:style="{
        bottom: isMobile ? 0 : topMargin + 'px',
        opacity: showImage ? '1' : '0'
      }"
    >
  </div>
  <p
      class="name-styled title-parallax title-text info-text"
      v-bind:style="{
        top: '' + titleAnimationMargin + '%',
        left: '0%'
      }"
    >
    <span style="font-size:60px;">Hej!</span>
    <br>Vi har flyttat vår bokning till GuMo.
    <br> Vi har inte öppnat bokning för vintersäsongen 2027 än. Men det går bra att boka fram till v.41.
    <br> Lilla stugan hittar du <a href="https://gumo.se/stuga/Hjortronvägen15Lilla">här</a>. Stora stugan hittar du <a href="https://gumo.se/stuga/Hjortronvägen15Stora">här</a>.
    </p>
    <!--
    <div 
      v-if="isMobile"
      class="header-div"
    >
    </div>
    <div 
      v-if="!isMobile"
      class="header-div"
      v-bind:style="{
        bottom: isMobile ? 0 : topMargin + 'px',
        opacity: showImage ? '1' : '0'
      }"
    ></div>
    <h1
      class="name-styled d-none d-lg-block title-parallax title-text title-big"
      v-bind:style="{
        opacity: showImage ? '1' : '0',
        top: '' + titleAnimationMargin + '%',
        left: '0%'
      }"
    >
    {{ $t('text.rent_a_cabin') }}<br>{{ $t('text.beautiful_salen') }}
    </h1>
  
    <h1
      class="name-styled name-styled d-md-block d-lg-none title-parallax title-text title-small"
      v-bind:style="{
        opacity: showImage ? '1' : '0',
        top: '' + titleAnimationMargin + '%',
        left: '0%'
      }"
    >
      {{ $t('text.rent_a_cabin') }}<br>{{ $t('text.beautiful_salen') }}
    </h1>
    
    
    <div class="check-availability-div"
      v-bind:style="{
        opacity: showImage ? '1' : '0',
        top: '' + calendarAnimationMargin + '%',
      }">
      <CheckAvailabilityDatePickerComponent class="check-availability"/>
    </div>
  -->
  </div>
  
  </Transition>
</template>

<script>
//import CheckAvailabilityDatePickerComponent from "../components/CheckAvailabilityDatePickerComponent.vue"

export default {
  name: "HeaderItem",
  components: {
    //CheckAvailabilityDatePickerComponent
    },
  data() {
    return {
      titleAnimationMargin: 30,
      titleAnimationLeft: 0,
      calendarAnimationMargin: 50,
      topMargin: 0,
      oldY: 0,
      showImage: false,
      isMobile: false
    };
  },
  methods: {
    handleScroll(event) {
      event.preventDefault();
      let offset = window.scrollY - this.oldY;
      this.titleAnimationMargin += offset * 0.05;
      this.calendarAnimationMargin += offset * 0.05;
      this.topMargin += offset * 0.4;
      this.oldY = window.scrollY;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.showImage = true;
    this.titleAnimationMargin = 20;
    this.titleAnimationLeft = -20;
    this.calendarAnimationMargin = 45;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
}

.header-div {
  background-image: url("../../assets/images/header.jpg");
  background-position: bottom;
  background-repeat: repeat;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  overflow: hidden;
  position: fixed;
  z-index: 0;
  height: 100%;
  width: 100%;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -ms-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;
}

.title-parallax {
  position: absolute;
}

.title-text {
  color: #000;
  height: 100%;
  width:100%;
}

.title-big {
  font-size: 70px;
}

.info-text {
  font-size: 30px;
}

.title-small {
  font-size: 50px;
}

/*
@font-face {
  font-family: 'better';
  src: url('../../assets/fonts/better.ttf');
}

.name-styled {
  font-family: 'better';
}*/

.name-styled {
  font-family: 'Georgia';
}

.and-styled {
  font-family: 'better';
  font-size: 60px;
  margin-top:-20px;
  margin-bottom:-20px;
}

.and-styled-small {
  font-family: 'better';
  margin-top:-20px;
  margin-bottom:-20px;
  font-size: 40px;
}

.book-button {
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 22px;
  padding-right: 22px;
  border:none;
  background-color: #000;
  color: #fff;
  border-radius: 4px;
  font-size: 20px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  bottom: 17%;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  position: fixed;
}

.check-availability-div {
  position: absolute;
  width: 100%;
  text-align: center;
  z-index: 0;
  
}

.check-availability {
  width: 80%;
  max-width: 400px;
  margin:auto;
  /*box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  padding: 20px;*/
}

.datepicker .datepicker--open .datepicker__inner{
  z-index: 1;
}
</style>
